import { Card, Flex, Space, Tag, Button } from 'antd'
import dayjs from 'dayjs'

import { GetTreatmentPlanRecipeResponse } from 'src/api/requests'
import { CallIcon } from 'src/assets'
import { Text } from 'src/components'
import { getRecipeStatus } from 'src/features/persons'
import { dayMonthYearHourMinutesFormatSeparator } from 'src/libs'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  data?: GetTreatmentPlanRecipeResponse
}

export const PrescriptionDetailsCard = ({ data }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()

  return (
    <Card className={styles.headerCard}>
      <Flex vertical gap={8} className="full-width">
        <Flex justify="space-between">
          <Space>
            <Text weight={400}>{t('investigations.created_date')}</Text>
            <Text strong>
              {dayjs(data?.dateIssued).format(
                dayMonthYearHourMinutesFormatSeparator
              )}
            </Text>
          </Space>

          <Tag color={getRecipeStatus(t, data?.status).color}>
            {getRecipeStatus(t, data?.status).text}
          </Tag>
        </Flex>

        <Space>
          <Text weight={400}>{t('recipes.person_who_created_the_recipe')}</Text>
          <Text strong>
            {data?.issuedBy?.firstName} {data?.issuedBy?.lastName} -{' '}
            {data?.legalEntity?.name}
          </Text>

          {data?.issuedBy?.phoneNumber && (
            <Button
              onClick={() =>
                window.open(`tel:${data?.issuedBy?.phoneNumber}`, '_blank')
              }
            >
              <CallIcon /> {data?.issuedBy?.phoneNumber}
            </Button>
          )}
        </Space>
      </Flex>
    </Card>
  )
}
